var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7673C0;}\r\n\t.st1{fill:#EB001B;}\r\n\t.st2{fill:#00A1DF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.8,
    y: 205.6,
    className: "st0",
    width: 216.3,
    height: 388.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    className: "st1",
    d: "M305.6,400c-0.1-75.9,34.8-147.6,94.5-194.4c-107.3-84.4-262.8-65.8-347.1,41.6 S-12.8,510,94.5,594.4c89.7,70.5,215.9,70.5,305.6,0C340.4,547.6,305.5,475.9,305.6,400z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M800,400c0,136.5-110.7,247.2-247.2,247.2c-55.4,0-109.2-18.6-152.8-52.9c107.3-84.4,125.9-239.9,41.5-347.2 c-12.1-15.4-26.1-29.4-41.5-41.5c107.4-84.4,262.8-65.7,347.1,41.6C781.4,290.8,800,344.6,800,400z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.7b2bb1bce9209b8dccd0a56cee5f5426.svg";
export { ForwardRef as ReactComponent };